import gsap from 'gsap';
import { fetchConfig } from '../helpers';
import { publish } from '../helpers/subscribe';

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

class AddToCart {

  constructor(element) {

    this.element = element

    this.form = this.element.querySelector("form");

    if (!this.form) return;

    this.submitBtn = this.form.querySelector("[type='submit']");
    this.plusBtn = this.form.querySelector(".btn-plus");
    this.minusBtn = this.form.querySelector(".btn-minus");
    this.qtyBtns = this.form.querySelectorAll(".btn-qty");
    this.submitBtnHtml = this.submitBtn?.innerHTML;
    this.processing = false;
    this.processingHtml = `<span style="opacity:0;">Processing ...</span>`;
    this.quantityInput = this.form.querySelector("[name='quantity']");
    this.cart = document.querySelector("cart-drawer")

    this.quickshop = this.element.dataset.quickshop === "true"

    this.productData = (this.form.querySelector("[name='data']")) ? JSON.parse(this.form.querySelector("[name='data']").value) : {};
    this.variantData = (this.form.querySelector("[name='variants']")) ? JSON.parse(this.form.querySelector("[name='variants']").value) : {};
    this.optionData = (this.form.querySelector("[name='options']")) ? JSON.parse(this.form.querySelector("[name='options']").value) : {};

    this.amountAdded = 0;

    /** Bind our form */
    this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
    this.qtyBtns.forEach((el) => el.addEventListener("click", this.updateHandler.bind(this)));
  }

  changeQuantity(event) {

  }

  /**
   * Add to cart form submission
   * @param {Object} event
   * @returns
   */
  onSubmitHandler(event) {


    event.preventDefault();

    if (this.processing === true) return;

    this.handleErrorMessage();

    /** Block multiple requests */
    this.submitBtn.setAttribute("aria-disabled", true);
    this.processing = true;
    this.runProcessingAnimation(true);

    /** Grab form data */
    const formData = new FormData(this.form);

    formData.append(
      'sections',
      this.cart.getSectionsToRender().map((section) => section.id)
    )
    formData.append('sections_url', window.location.pathname)
    this.cart.setActiveElement(document.activeElement)

    /** Safari fallback */
    if (!formData.get("quantity") && this.form.querySelector("[name='quantity']")) {
      formData.append("quantity", this.form.querySelector("[name='quantity']").value);
    }

    const config = fetchConfig('javascript')
    config.headers['X-Requested-With'] = 'XMLHttpRequest'
    delete config.headers['Content-Type']

    config.body = formData


    /** Submit product form */
    fetch(`${routes.cart_add_url}`, config)
      .then(response => response.json())
      .then(async (response) => {



        if (response.status) {

          this.handleErrorMessage(response.description);

          return;
        }

        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'product-form',
          productVariantId: formData.get('id'),
          cartData: response,
        });


        this.cart.renderContents(response);
        this.cart.classList.remove("is-empty")


        // checkCart();
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        this.submitBtn.removeAttribute("aria-disabled");
        this.processing = false;

        // this.runProcessingAnimation();

        this.amountAdded = 1;
        // get the cart component and call
        this.renderButtons()
      });
  }

  updateHandler(event) {
    event.preventDefault()

    event.target.setAttribute("aria-disabled", true)

    if (event.target == this.minusBtn || event.currentTarget === this.minusBtn || event.target.parentElement === this.minusBtn) {

      this.quantityInput.value--
      this.amountAdded--
    } else {
      this.quantityInput.value++
      this.amountAdded++
    }

    const updates = {
      [this.form.querySelector("[name='id']").value]: parseInt(this.quantityInput.value)
    }

    fetch(routes.cart_update_url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ updates })
    })
      .then(response => response.json())
      .then(async (response) => {

        if (response.status) {

          this.handleErrorMessage(response.description);

          return;
        }


        if (self.Decimal?.Cart?.el) self.Zero.Cart.el.forceUpdate(true);

        // checkCart();
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        event.target.removeAttribute("aria-disabled");
        this.processing = false;
        const cart = document.querySelector("cart-drawer")
        cart.open()
        // this.runProcessingAnimation();

        this.renderButtons()
      });
  }


  renderButtons() {

    if (!this.quickshop) {

      if (this.amountAdded === 0) {
        this.submitBtn.innerHTML = "Add to Cart"
        this.submitBtn.disabled = false
        this.qtyBtns.forEach((el) => el.classList.add("hidden"))
      } else {
        this.submitBtn.disabled = true
        this.submitBtn.innerHTML = `${this.amountAdded} Added`
        this.qtyBtns.forEach((el) => el.classList.remove("hidden"))
      }
    }
  }
  /**
   * Add to cart form submission
   * @param {element} errorMessage
   * @returns
   */
  handleErrorMessage(errorMessage = false) {

    this.errorMessageWrapper = this.errorMessageWrapper || this.element.querySelector(".error-message-wrapper");
    this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector(".error-message");

    this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

    if (errorMessage) this.errorMessage.textContent = errorMessage;
  }

  /**
   * Add to cart feedback event
   * @param {boolean} run
   * @returns
   */
  runProcessingAnimation(run = false) {

    if (!run) {

      gsap.to(this.submitBtn.children, {
        opacity: 0, duration: 0.1, onComplete: () => {
          this.submitBtn.innerHTML = this.submitBtnHtml;
          gsap.set(this.submitBtn.children, { opacity: 0 });
          gsap.to(this.submitBtn.children, { opacity: 1, duration: 0.1 });
        }
      });

      return;
    }

    if (!this.quickshop) {

      gsap.to(this.submitBtn.children, {
        opacity: 0, duration: 0.1, onComplete: () => {

          this.submitBtn.innerHTML = this.processingHtml;

          gsap.to(this.submitBtn.children, { opacity: 1, duration: 0.1 });
        }
      });
    }
  }
}

// IIFE to invoke component on mount
(function init() {
  const addToCartEls = document.querySelectorAll('[data-add-to-cart]')

  addToCartEls.forEach((el, i, arr) => {
    if (el.getAttribute('bound') !== null) return

    const addToCart = new AddToCart(el)

    el.setAttribute('bound', '')

    const id = arr.length > 1 ? `AddToCart_${i}` : 'AddToCart'

    self.Decimal.components[id] = { ...addToCart, async: true }
  })
})()
